import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AdminSharedModule } from '@modules/admin-shared/admin-shared.module';
import { ImageModule } from '@components/admin/image/image.module';
import { FileUploadModule } from 'ng2-file-upload';
import { InventoryComponent } from '@components/admin/inventory/inventory.component';
import { VendorBaseComponent } from '@components/admin/inventory/vendor-base/vendor-base.component';
import { InventoryBaseComponent } from '@components/admin/inventory/inventory-base/inventory-base.component';
import { InventoryHistoryComponent } from '@components/admin/inventory/inventory-history/inventory-history.component';
import { PriceCheckComponent } from '@components/admin/inventory/price-check/price-check.component';
import { InventoryMenuComponent } from '@components/admin/inventory/inventory-menu/inventory-menu.component';
import { ReturnInventoryDialogComponent } from '@components/admin/inventory/return-inventory-dialog/return-inventory-dialog.component';

const INVENTORY_DECLARATIONS = [
  InventoryComponent,
  VendorBaseComponent,
  InventoryBaseComponent,
  InventoryHistoryComponent,
  PriceCheckComponent,
  InventoryMenuComponent,
  ReturnInventoryDialogComponent,
];

@NgModule({
  declarations: INVENTORY_DECLARATIONS,
  imports: [AdminSharedModule, ImageModule, FileUploadModule],
  exports: INVENTORY_DECLARATIONS,
  entryComponents: [PriceCheckComponent, ReturnInventoryDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InventoryModule {}
